import { render, staticRenderFns } from "./CuCastingSpecsCard.vue?vue&type=template&id=f940fee8"
import script from "./CuCastingSpecsCard.vue?vue&type=script&lang=js"
export * from "./CuCastingSpecsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports